
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('parameterDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <label v-if="this.$parent.parameterContainsEvaluation" class="form-label">{{ $t('parameterContainsEvaluation') }}</label>
                    <label v-if="this.$parent.parameterContainsCurves" class="form-label">{{ $t('parameterContainsCurves') }}</label>
                    <!-- <template  v-else-if="this.$parent.foundAssetTypes.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteAssetType') }}</label>
                        <div v-for="(assetType, i) in this.$parent.foundAssetTypes" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/forecast/' + assetType.forecastId ">
                                {{ assetType.name }}
                            </RouterLink>
                        </div>
                    </template> -->
                    <p v-else>{{ $t('wannaDeleteThisParameter') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteParameter" :disabled="this.$parent.parameterContainsEvaluation || this.$parent.parameterContainsCurves" >
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import { setTransitionHooks } from "vue";
import ParameterApi from "../../api/server/parameter";

export default {
    name: "parameterDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteParameter() {
            await ParameterApi.parameterDelete(this.$parent.$route.params.id, this.$parent.parameterToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};
</script>